import { render, staticRenderFns } from "./VEmployeeProfileEmployment.vue?vue&type=template&id=69e39a24&lang=pug"
import script from "./VEmployeeProfileEmployment.vue?vue&type=script&lang=ts"
export * from "./VEmployeeProfileEmployment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmployeeProfileEmployment.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployee%2Fviews%2FProfile%2Fviews%2FEmployment%2FVEmployeeProfileEmployment.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports